"use client";

import { useEffect } from 'react';

/** The shared root layout persists during client-side locale navigation. */
export function DocumentLanguage({ locale }: { locale: string }) {
  useEffect(() => { document.documentElement.lang = locale; }, [locale]);
  return null;
}
